/**
 * Format a duration in milliseconds for compact display.
 *
 *   v < 1 000     →  "{N}ms"        (ex. "742ms")
 *   v < 60 000    →  "{N.N}s"       (ex. "12.4s")
 *   v >= 60 000   →  "{M}min {S}s"  (ex. "9min 41s")
 *
 * Returns "—" for null / undefined.
 *
 * Shared between ``ExperimentMetricsPanel``, ``ExperimentComparisonView``, and
 * ``RunsTable`` — formerly duplicated in each, which let raw ``{Math.round(v)}ms``
 * snippets creep back in (visible on a 581 562 ms latency rendered as
 * ``581562ms`` in the runs table).
 */
export function fmtMs(v: number | null | undefined): string {
  if (v === null || v === undefined) return "—";
  if (v < 1_000) return `${Math.round(v)}ms`;
  if (v < 60_000) return `${(v / 1_000).toFixed(1)}s`;
  const totalSec = Math.round(v / 1_000);
  const min = Math.floor(totalSec / 60);
  const sec = totalSec % 60;
  return sec === 0 ? `${min}min` : `${min}min ${sec}s`;
}
